import { render, staticRenderFns } from "./EtapaRevisao.vue?vue&type=template&id=0a9d425f&scoped=true"
import script from "./EtapaRevisao.vue?vue&type=script&lang=js"
export * from "./EtapaRevisao.vue?vue&type=script&lang=js"
import style0 from "./EtapaRevisao.vue?vue&type=style&index=0&id=0a9d425f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9d425f",
  null
  
)

export default component.exports